// extracted by mini-css-extract-plugin
export default {"purchase":"PurchaseTerm_purchase__bWEk+","download_btn":"PurchaseTerm_download_btn__L34Dp"};